/**
 * This file is auto-generated by 'libs/cms-sitecore/src/generate-collision-names.ts'
 * from '@eneco/cms-sanity-schema/component-map.json'. Do not manually edit; your changes might get lost.
 *
 * The Sanity name of every group member whose field name another section of the same component
 * also holds, or which Sanity spells differently: keyed by Sanity type, then payload folder (see
 * `folderKey`), then Sitecore field name.
 */
import type { CollisionNames } from './field-groups';

export const COLLISION_NAMES: Readonly<Record<string, CollisionNames>> = {
  AccountSelectStep: {
    accountselect: {
      title: 'accountSelect_title',
    },
    content: {
      title: 'content_title',
    },
  },
  AdvancedCalculationTool: {
    content: {
      title: 'content_title',
    },
    errorstate: {
      title: 'errorState_title',
    },
  },
  AffiliateCalculationTool: {
    errorstate: {
      title: 'errorState_title',
    },
    offerstate: {
      text: 'offerState_text',
      title: 'offerState_title',
    },
    usagestate: {
      text: 'usageState_text',
      title: 'usageState_title',
    },
  },
  BbpCampaign: {
    changeadvance: {
      addressLabel: 'changeAdvance_addressLabel',
      confirmButtonLink: 'changeAdvance_confirmButtonLink',
      currentAdvanceTitle: 'changeAdvance_currentAdvanceTitle',
      description: 'changeAdvance_description',
      text: 'changeAdvance_text',
      totalPerMonthText: 'changeAdvance_totalPerMonthText',
      updateFailedLabel: 'changeAdvance_updateFailedLabel',
      updateSuccessfulLabel: 'changeAdvance_updateSuccessfulLabel',
    },
    currentadvance: {
      addressLabel: 'currentAdvance_addressLabel',
      confirmButtonLink: 'currentAdvance_confirmButtonLink',
      currentAdvanceTitle: 'currentAdvance_currentAdvanceTitle',
      description: 'currentAdvance_description',
      text: 'currentAdvance_text',
      totalPerMonthText: 'currentAdvance_totalPerMonthText',
      updateFailedLabel: 'currentAdvance_updateFailedLabel',
      updateSuccessfulLabel: 'currentAdvance_updateSuccessfulLabel',
    },
  },
  BundleFlowSummaryStep: {
    content: {
      title: 'content_title',
    },
    personaldetails: {
      title: 'personalDetails_title',
    },
    productdetails: {
      title: 'productDetails_title',
    },
  },
  CancelationSummaryStep: {
    cancelationoverview: {
      title: 'cancelationOverview_title',
    },
    content: {
      title: 'content_title',
    },
    personaldetailsoverview: {
      title: 'personalDetailsOverview_title',
    },
    userdetails: {
      title: 'userDetails_title',
    },
  },
  ConsumptionGraphicalOverview: {
    advancecard: {
      title: 'advanceCard_title',
    },
    data: {
      Smr3SwitchDescription: 'smr3SwitchDescription',
      Smr3SwitchLink: 'smr3SwitchLink',
      title: 'data_title',
    },
    legend: {
      title: 'legend_title',
    },
  },
  ContactDetailsStep: {
    content: {
      title: 'Content_title',
    },
    optin: {
      title: 'Optin_title',
    },
  },
  ContactUs: {
    banner: {
      title: 'banner_title',
    },
    loginproposal: {
      title: 'loginProposal_title',
    },
  },
  ContractExtensionDetailsStep: {
    content: {
      title: 'Content_title',
    },
    personaldetailsoverview: {
      title: 'personalDetailsOverview_title',
    },
  },
  CorrectionInvoiceForm: {
    formfieldscorrectionrequest: {
      title: 'formFieldsCorrectionRequest_title',
    },
    formfieldsinvoice: {
      title: 'formFieldsInvoice_title',
    },
    formfieldsmeterreadings: {
      title: 'formFieldsMeterReadings_title',
    },
    formfieldspersonal: {
      title: 'formFieldsPersonal_title',
    },
    header: {
      title: 'Header_title',
    },
  },
  CvKetelKoopFlowContactDetailsStep: {
    content: {
      title: 'content_title',
    },
    optin: {
      title: 'optIn_title',
    },
  },
  Dashboard: {
    header: {
      Image: 'image',
    },
  },
  DashboardOverview: {
    activeproductscard: {
      link: 'activeProductsCard_link',
      title: 'activeProductsCard_title',
    },
    advanceamountchangedcard: {
      description: 'advanceAmountChangedCard_description',
      invoiceOverviewLink: 'advanceAmountChangedCard_invoiceOverviewLink',
      link: 'advanceAmountChangedCard_link',
      prepaymentMeterNotification: 'advanceAmountChangedCard_prepaymentMeterNotification',
      title: 'advanceAmountChangedCard_title',
    },
    anticipationannouncementcard: {
      description: 'anticipationAnnouncementCard_description',
      image: 'anticipationAnnouncementCard_image',
      title: 'anticipationAnnouncementCard_title',
    },
    brandbenefitscard: {
      benefitFourContent: 'brandBenefitsCard_benefitFourContent',
      benefitOneContent: 'brandBenefitsCard_benefitOneContent',
      benefitThreeContent: 'brandBenefitsCard_benefitThreeContent',
      benefitTwoContent: 'brandBenefitsCard_benefitTwoContent',
      changeLink: 'brandBenefitsCard_changeLink',
      description: 'brandBenefitsCard_description',
      title: 'brandBenefitsCard_title',
    },
    comfortbonuscard: {
      levelOneContent: 'comfortBonusCard_levelOneContent',
      levelOneLink: 'comfortBonusCard_levelOneLink',
      levelOneTitle: 'comfortBonusCard_levelOneTitle',
      levelTwoContent: 'comfortBonusCard_levelTwoContent',
      levelTwoLink: 'comfortBonusCard_levelTwoLink',
      levelTwoTitle: 'comfortBonusCard_levelTwoTitle',
      levelZeroContent: 'comfortBonusCard_levelZeroContent',
      levelZeroLink: 'comfortBonusCard_levelZeroLink',
      levelZeroTitle: 'comfortBonusCard_levelZeroTitle',
      title: 'comfortBonusCard_title',
    },
    comfortbonuscardb2b: {
      levelOneContent: 'comfortBonusCardB2b_levelOneContent',
      levelOneLink: 'comfortBonusCardB2b_levelOneLink',
      levelOneTitle: 'comfortBonusCardB2b_levelOneTitle',
      levelTwoContent: 'comfortBonusCardB2b_levelTwoContent',
      levelTwoLink: 'comfortBonusCardB2b_levelTwoLink',
      levelTwoTitle: 'comfortBonusCardB2b_levelTwoTitle',
      levelZeroContent: 'comfortBonusCardB2b_levelZeroContent',
      levelZeroLink: 'comfortBonusCardB2b_levelZeroLink',
      levelZeroTitle: 'comfortBonusCardB2b_levelZeroTitle',
      title: 'comfortBonusCardB2b_title',
    },
    completedprogresstimelinecard: {
      stepFourDescription: 'completedProgressTimelineCard_stepFourDescription',
      stepFourTitle: 'completedProgressTimelineCard_stepFourTitle',
      stepOneDescription: 'completedProgressTimelineCard_stepOneDescription',
      stepOneTitle: 'completedProgressTimelineCard_stepOneTitle',
      stepThreeDescription: 'completedProgressTimelineCard_stepThreeDescription',
      stepThreeTitle: 'completedProgressTimelineCard_stepThreeTitle',
      stepTwoDescription: 'completedProgressTimelineCard_stepTwoDescription',
      stepTwoTitle: 'completedProgressTimelineCard_stepTwoTitle',
      title: 'completedProgressTimelineCard_title',
    },
    completemovefilecard: {
      description: 'completeMoveFileCard_description',
      link: 'completeMoveFileCard_link',
      title: 'completeMoveFileCard_title',
    },
    configureitsmecard: {
      description: 'configureItsmeCard_description',
      link: 'configureItsmeCard_link',
      title: 'configureItsmeCard_title',
    },
    content: {
      title: 'Content_title',
    },
    currentadvanceamountvsrecommended: {
      description: 'currentAdvanceAmountVsRecommended_description',
      invoiceOverviewLink: 'currentAdvanceAmountVsRecommended_invoiceOverviewLink',
      link: 'currentAdvanceAmountVsRecommended_link',
      prepaymentMeterNotification: 'currentAdvanceAmountVsRecommended_prepaymentMeterNotification',
      title: 'currentAdvanceAmountVsRecommended_title',
    },
    deliverycountdowncard: {
      description: 'deliveryCountdownCard_description',
      image: 'deliveryCountdownCard_image',
      productsTitle: 'deliveryCountdownCard_productsTitle',
      title: 'deliveryCountdownCard_title',
    },
    faqcard: {
      answerFourContent: 'faqCard_answerFourContent',
      answerOneContent: 'faqCard_answerOneContent',
      answerThreeContent: 'faqCard_answerThreeContent',
      answerTwoContent: 'faqCard_answerTwoContent',
      changeLink: 'faqCard_changeLink',
      description: 'faqCard_description',
      questionFourText: 'faqCard_questionFourText',
      questionOneText: 'faqCard_questionOneText',
      questionThreeText: 'faqCard_questionThreeText',
      questionTwoText: 'faqCard_questionTwoText',
      title: 'faqCard_title',
    },
    intermediatesettlementbillinclreasoncard: {
      description: 'intermediateSettlementBillInclReasonCard_description',
      invoicesLink: 'intermediateSettlementBillInclReasonCard_invoicesLink',
      payLink: 'intermediateSettlementBillInclReasonCard_payLink',
      title: 'intermediateSettlementBillInclReasonCard_title',
    },
    marketingpropositioncard: {
      benefitFourContent: 'marketingPropositionCard_benefitFourContent',
      benefitOneContent: 'marketingPropositionCard_benefitOneContent',
      benefitThreeContent: 'marketingPropositionCard_benefitThreeContent',
      benefitTwoContent: 'marketingPropositionCard_benefitTwoContent',
      changeLink: 'marketingPropositionCard_changeLink',
      title: 'marketingPropositionCard_title',
    },
    monthlybillingcard: {
      description: 'monthlyBillingCard_description',
      link: 'monthlyBillingCard_link',
      title: 'monthlyBillingCard_title',
    },
    movefilecreatedcard: {
      description: 'moveFileCreatedCard_description',
      image: 'moveFileCreatedCard_image',
      link: 'moveFileCreatedCard_link',
      title: 'moveFileCreatedCard_title',
    },
    noopenamountcard: {
      directDebitExcludingYearlyBillText: 'noOpenAmountCard_directDebitExcludingYearlyBillText',
      directDebitIncludingYearlyBillText: 'noOpenAmountCard_directDebitIncludingYearlyBillText',
      link: 'noOpenAmountCard_link',
      noOpenAmountText: 'noOpenAmountCard_noOpenAmountText',
      title: 'noOpenAmountCard_title',
    },
    orderstatuscard: {
      description: 'orderStatusCard_description',
      electricityLabel: 'orderStatusCard_electricityLabel',
      gasLabel: 'orderStatusCard_gasLabel',
      link: 'orderStatusCard_link',
      productsTitle: 'orderStatusCard_productsTitle',
      title: 'orderStatusCard_title',
    },
    payinvoicecard: {
      directDebitExcludingYearlyBillText: 'payInvoiceCard_directDebitExcludingYearlyBillText',
      directDebitIncludingYearlyBillText: 'payInvoiceCard_directDebitIncludingYearlyBillText',
      invoicesLink: 'payInvoiceCard_invoicesLink',
      link: 'payInvoiceCard_link',
      noOpenAmountText: 'payInvoiceCard_noOpenAmountText',
      payLink: 'payInvoiceCard_payLink',
      title: 'payInvoiceCard_title',
    },
    paymentmethodchangefailedcard: {
      title: 'paymentMethodChangeFailedCard_title',
    },
    paymentplaninstallmentcard: {
      link: 'paymentPlanInstallmentCard_link',
      title: 'paymentPlanInstallmentCard_title',
    },
    predeliveryfaqcard: {
      answerFourContent: 'preDeliveryFAQCard_answerFourContent',
      answerOneContent: 'preDeliveryFAQCard_answerOneContent',
      answerThreeContent: 'preDeliveryFAQCard_answerThreeContent',
      answerTwoContent: 'preDeliveryFAQCard_answerTwoContent',
      changeLink: 'preDeliveryFAQCard_changeLink',
      description: 'preDeliveryFAQCard_description',
      questionFourText: 'preDeliveryFAQCard_questionFourText',
      questionOneText: 'preDeliveryFAQCard_questionOneText',
      questionThreeText: 'preDeliveryFAQCard_questionThreeText',
      questionTwoText: 'preDeliveryFAQCard_questionTwoText',
      title: 'preDeliveryFAQCard_title',
    },
    productconfirmationcard: {
      description: 'productConfirmationCard_description',
      link: 'productConfirmationCard_link',
      title: 'productConfirmationCard_title',
    },
    progresstimelinecard: {
      stepFourDescription: 'progressTimelineCard_stepFourDescription',
      stepFourTitle: 'progressTimelineCard_stepFourTitle',
      stepOneDescription: 'progressTimelineCard_stepOneDescription',
      stepOneTitle: 'progressTimelineCard_stepOneTitle',
      stepThreeDescription: 'progressTimelineCard_stepThreeDescription',
      stepThreeTitle: 'progressTimelineCard_stepThreeTitle',
      stepTwoDescription: 'progressTimelineCard_stepTwoDescription',
      stepTwoTitle: 'progressTimelineCard_stepTwoTitle',
      title: 'progressTimelineCard_title',
    },
    pushdirectdebitcard: {
      changeLink: 'PushDirectDebitCard_changeLink',
      description: 'PushDirectDebitCard_description',
      title: 'PushDirectDebitCard_title',
    },
    refertoaccountnumberifrefundcard: {
      invoicesLink: 'referToAccountNumberIfRefundCard_invoicesLink',
      payLink: 'referToAccountNumberIfRefundCard_payLink',
      title: 'referToAccountNumberIfRefundCard_title',
    },
    showpersonalinfocard: {
      link: 'showPersonalInfoCard_link',
      title: 'showPersonalInfoCard_title',
    },
    showusagecard: {
      electricityLabel: 'showUsageCard_electricityLabel',
      gasLabel: 'showUsageCard_gasLabel',
      title: 'showUsageCard_title',
    },
    thankyoucard: {
      description: 'thankYouCard_description',
      image: 'thankYouCard_image',
      title: 'thankYouCard_title',
    },
  },
  DashboardV2: {
    advancepayment: {
      AdvancePaymentSingleCostInvoiceText: 'advancePaymentSingleCostInvoiceText',
    },
  },
  DecarbonizationLeadFlowSummaryStep: {
    companydetails: {
      sectionTitle: 'companyDetails_sectionTitle',
    },
    content: {
      title: 'content_title',
    },
    isbusinesscustomer: {
      sectionTitle: 'isBusinessCustomer_sectionTitle',
    },
    paymentdetails: {
      title: 'Paymentdetails_title',
    },
    personaldetailsoverview: {
      title: 'Personaldetailsoverview_title',
    },
    productsoverview: {
      title: 'Productsoverview_title',
    },
  },
  DecarbonizationPotentialBreakdown: {
    calculationsoutcome: {
      description: 'calculationsOutcome_description',
      title: 'calculationsOutcome_title',
    },
    content: {
      buttonLink: 'content_buttonLink',
      image: 'content_image',
      title: 'content_title',
    },
    noresultsoutcome: {
      buttonLink: 'noResultsOutcome_buttonLink',
      description: 'noResultsOutcome_description',
      image: 'noResultsOutcome_image',
      title: 'noResultsOutcome_title',
    },
  },
  DeceasedFlowMonthlyInstallmentPaymentMethodStep: {
    content: {
      title: 'content_title',
    },
    currentpaymentdetailscard: {
      title: 'CurrentPaymentDetailsCard_title',
    },
  },
  DeceasedFlowOverviewStep: {
    content: {
      title: 'content_title',
    },
    contractcard: {
      title: 'contractCard_title',
    },
    dateofpassingcard: {
      givenDateLabel: 'dateOfPassingCard_givenDateLabel',
      title: 'dateOfPassingCard_title',
    },
    deceasedpersondetailscard: {
      emailAddressLabel: 'deceasedPersonDetailsCard_emailAddressLabel',
      title: 'deceasedPersonDetailsCard_title',
    },
    keyhandoverdatecard: {
      givenDateLabel: 'keyHandoverDateCard_givenDateLabel',
      title: 'keyHandoverDateCard_title',
    },
    nextofkindetailscard: {
      emailAddressLabel: 'nextOfKinDetailsCard_emailAddressLabel',
      title: 'nextOfKinDetailsCard_title',
    },
    paymentdetailscard: {
      title: 'paymentDetailsCard_title',
    },
  },
  DeceasedForm: {
    contactformfields: {
      description: 'contactFormFields_description',
      houseNumberFormField: 'contactFormFields_houseNumberFormField',
      houseNumberSuffixFormField: 'contactFormFields_houseNumberSuffixFormField',
      postalCodeFormField: 'contactFormFields_postalCodeFormField',
      title: 'contactFormFields_title',
    },
    deceasedformfields: {
      description: 'deceasedFormFields_description',
      houseNumberFormField: 'deceasedFormFields_houseNumberFormField',
      houseNumberSuffixFormField: 'deceasedFormFields_houseNumberSuffixFormField',
      postalCodeFormField: 'deceasedFormFields_postalCodeFormField',
      title: 'deceasedFormFields_title',
    },
    footer: {
      description: 'footer_description',
      title: 'footer_title',
    },
    header: {
      description: 'header_description',
      title: 'header_title',
    },
  },
  DongleFlowOfferStep: {
    content: {
      text: 'content_text',
      title: 'content_title',
    },
    productdetails: {
      text: 'productDetails_text',
      title: 'productDetails_title',
    },
  },
  DongleFlowSmartMeterStep: {
    content: {
      title: 'content_title',
    },
    unsuitable: {
      title: 'unsuitable_title',
    },
  },
  DongleFlowSummaryStep: {
    content: {
      title: 'content_title',
    },
    personaldetails: {
      title: 'personalDetails_title',
    },
    productdetails: {
      title: 'productDetails_title',
    },
  },
  GenericCheckboxChoiceStep: {
    content: {
      title: 'Content_title',
    },
    moreinfodialog: {
      title: 'moreInfoDialog_title',
    },
  },
  GenericChoiceStep: {
    content: {
      title: 'Content_title',
    },
    moreinfodialog: {
      title: 'moreInfoDialog_title',
    },
  },
  GenericRadioChoiceStep: {
    content: {
      title: 'Content_title',
    },
    moreinfodialog: {
      title: 'moreInfoDialog_title',
    },
  },
  HeatComparisonTool: {
    address: {
      content: 'address_content',
    },
    content: {
      title: 'content_title',
    },
    costbreakdown: {
      annualCO2EmissionsLabel: 'costBreakdown_annualCO2EmissionsLabel',
      content: 'costBreakdown_content',
      estimatedUsageCostsPerMonthLabel: 'costBreakdown_estimatedUsageCostsPerMonthLabel',
      estimatedUsagePerYearLabel: 'costBreakdown_estimatedUsagePerYearLabel',
      naturalGasLabel: 'costBreakdown_naturalGasLabel',
      title: 'costBreakdown_title',
      warmthLabel: 'costBreakdown_warmthLabel',
    },
    gasusage: {
      content: 'gasUsage_content',
    },
    result: {
      annualCO2EmissionsLabel: 'result_annualCO2EmissionsLabel',
      estimatedUsageCostsPerMonthLabel: 'result_estimatedUsageCostsPerMonthLabel',
      estimatedUsagePerYearLabel: 'result_estimatedUsagePerYearLabel',
      naturalGasLabel: 'result_naturalGasLabel',
      warmthLabel: 'result_warmthLabel',
    },
  },
  HeatPumpLeadFlowContactDetailsStep: {
    content: {
      title: 'content_title',
    },
    optin: {
      title: 'optIn_title',
    },
  },
  HomeBatteryLeadFlowSummaryStep: {
    addressdetails: {
      title: 'addressDetails_title',
    },
    contactdetails: {
      title: 'contactDetails_title',
    },
    content: {
      title: 'content_title',
    },
    personaldetails: {
      title: 'personalDetails_title',
    },
    privacy: {
      title: 'privacy_title',
    },
    products: {
      title: 'products_title',
    },
  },
  ItsMeMergeAccount: {
    oktamatch: {
      content: 'oktaMatch_content',
      title: 'oktaMatch_title',
    },
    oktanomatch: {
      content: 'oktaNoMatch_content',
      title: 'oktaNoMatch_title',
    },
  },
  KetelComfortOverviewStep: {
    content: {
      text: 'content_text',
      title: 'content_title',
    },
    costdetails: {
      text: 'costDetails_text',
    },
    productsoverview: {
      title: 'productsOverview_title',
    },
  },
  KetelComfortPersonalDetailsStep: {
    content: {
      text: 'content_text',
      title: 'content_title',
    },
    login: {
      text: 'login_text',
      title: 'login_title',
    },
  },
  ManageAdvanceAmount: {
    advanceamountimpact: {
      eanLabel: 'advanceAmountImpact_eanLabel',
      title: 'advanceAmountImpact_title',
    },
    advancecard: {
      title: 'advanceCard_title',
    },
    commoditycard: {
      eanLabel: 'commodityCard_eanLabel',
      title: 'commodityCard_title',
    },
    data: {
      title: 'data_title',
    },
    vacancycard: {
      title: 'vacancyCard_title',
    },
  },
  MissingEAN: {
    content: {
      title: 'content_title',
    },
    eandetails: {
      title: 'eanDetails_title',
    },
    personaldetails: {
      title: 'personalDetails_title',
    },
  },
  MoveBillingAddressStep: {
    addressform: {
      title: 'addressForm_title',
    },
    dataform: {
      title: 'dataForm_title',
    },
  },
  MoveEODUpload: {
    advantagescard: {
      description: 'advantagesCard_description',
      title: 'advantagesCard_title',
    },
    uploadform: {
      description: 'uploadForm_description',
      title: 'uploadForm_title',
    },
  },
  MoveFileAddressDetails: {
    address: {
      title: 'address_title',
    },
    contactdetails: {
      title: 'contactDetails_title',
    },
    electricitymeter: {
      changeMeterLink: 'electricityMeter_changeMeterLink',
      defaultRateLabel: 'electricityMeter_defaultRateLabel',
      description: 'electricityMeter_description',
      eanLabel: 'electricityMeter_eanLabel',
      numberLabel: 'electricityMeter_numberLabel',
      title: 'electricityMeter_title',
    },
    eodupload: {
      description: 'eodUpload_description',
      title: 'eodUpload_title',
    },
    gasmeter: {
      changeMeterLink: 'gasMeter_changeMeterLink',
      defaultRateLabel: 'gasMeter_defaultRateLabel',
      description: 'gasMeter_description',
      eanLabel: 'gasMeter_eanLabel',
      numberLabel: 'gasMeter_numberLabel',
      title: 'gasMeter_title',
    },
  },
  MoveFileContactDetails: {
    billingaddress: {
      link: 'billingAddress_link',
      title: 'billingAddress_title',
    },
    changeinfo: {
      link: 'changeInfo_link',
      title: 'changeInfo_title',
    },
    knowninfo: {
      title: 'knownInfo_title',
    },
  },
  MoveInDateStep: {
    credentialscard: {
      title: 'credentialsCard_title',
    },
    moveindateform: {
      title: 'moveInDateForm_title',
    },
  },
  MoveNewAddressStep: {
    addressform: {
      description: 'addressForm_description',
      title: 'addressForm_title',
    },
    eodreceived: {
      description: 'eodReceived_description',
      title: 'eodReceived_title',
    },
  },
  MoveOnboarding: {
    movecancelteaser: {
      cancelFlowLink: 'moveCancelTeaser_cancelFlowLink',
      title: 'moveCancelTeaser_title',
    },
    movefileemptyteaser: {
      title: 'moveFileEmptyTeaser_title',
    },
    movefileteaser: {
      cancelFlowLink: 'moveFileTeaser_cancelFlowLink',
      title: 'moveFileTeaser_title',
    },
    onboarding: {
      title: 'onboarding_title',
    },
  },
  MoveOutConfirmationStep: {
    contactinfo: {
      label: 'contactInfo_label',
    },
    content: {
      content: 'content_content',
    },
    currentaddress: {
      label: 'currentAddress_label',
    },
    formfeedbackerror: {
      content: 'formFeedbackError_content',
      title: 'formFeedbackError_title',
    },
    formfeedbacksuccess: {
      content: 'formFeedbackSuccess_content',
      title: 'formFeedbackSuccess_title',
    },
    formputmoveindateinvalid: {
      content: 'formPutMoveInDateInvalid_content',
      title: 'formPutMoveInDateInvalid_title',
    },
    formputmoveoutdateinvalid: {
      content: 'formPutMoveOutDateInvalid_content',
      title: 'formPutMoveOutDateInvalid_title',
    },
    formputrelocationdisallowed: {
      content: 'formPutRelocationDisallowed_content',
      title: 'formPutRelocationDisallowed_title',
    },
    header: {
      title: 'header_title',
    },
    moveoutdate: {
      label: 'moveOutDate_label',
    },
    products: {
      title: 'products_title',
    },
  },
  MoveOutDateStep: {
    moveoutaddress: {
      label: 'moveOutAddress_label',
    },
    products: {
      label: 'products_label',
    },
  },
  MoveOutDisallowed: {
    alreadyhasrelocation: {
      description: 'alreadyHasRelocation_description',
      link: 'alreadyHasRelocation_link',
      title: 'alreadyHasRelocation_title',
    },
    contractalreadycancelled: {
      description: 'contractAlreadyCancelled_description',
      link: 'contractAlreadyCancelled_link',
      title: 'contractAlreadyCancelled_title',
    },
    other: {
      description: 'other_description',
      link: 'other_link',
      title: 'other_title',
    },
    productscantbemovedonline: {
      description: 'productsCantBeMovedOnline_description',
      link: 'productsCantBeMovedOnline_link',
      title: 'productsCantBeMovedOnline_title',
    },
  },
  MoveOverviewStep: {
    newaddresscard: {
      addressLabel: 'newAddressCard_addressLabel',
      energyTypeLabel: 'newAddressCard_energyTypeLabel',
      energyTypesList: 'newAddressCard_energyTypesList',
      eodChangeLink: 'newAddressCard_eodChangeLink',
      eodFileNameLabel: 'newAddressCard_eodFileNameLabel',
      eodSuccessDescription: 'newAddressCard_eodSuccessDescription',
    },
    oldaddresscard: {
      addressLabel: 'oldAddressCard_addressLabel',
      energyTypeLabel: 'oldAddressCard_energyTypeLabel',
      energyTypesList: 'oldAddressCard_energyTypesList',
      eodChangeLink: 'oldAddressCard_eodChangeLink',
      eodFileNameLabel: 'oldAddressCard_eodFileNameLabel',
      eodSuccessDescription: 'oldAddressCard_eodSuccessDescription',
    },
  },
  MoveResidentChangeContactDetails: {
    contactform: {
      title: 'contactForm_title',
    },
    contractdetails: {
      title: 'contractDetails_title',
    },
  },
  MovingOutDateStep: {
    credentialscard: {
      title: 'credentialsCard_title',
    },
    moveoutdateform: {
      title: 'moveOutDateForm_title',
    },
  },
  MyEnecoComfortBonus: {
    comfortbonus: {
      assistanceAbroadContent: 'ComfortBonus_assistanceAbroadContent',
      assistanceBelgiumContent: 'ComfortBonus_assistanceBelgiumContent',
      content: 'ComfortBonus_content',
      infoLink: 'ComfortBonus_infoLink',
      levelOneContent: 'ComfortBonus_levelOneContent',
      levelOneTitle: 'ComfortBonus_levelOneTitle',
      levelTwoContent: 'ComfortBonus_levelTwoContent',
      levelTwoTitle: 'ComfortBonus_levelTwoTitle',
      levelZeroContent: 'ComfortBonus_levelZeroContent',
      title: 'ComfortBonus_title',
    },
    comfortbonusb2b: {
      assistanceAbroadContent: 'comfortBonusB2b_assistanceAbroadContent',
      assistanceBelgiumContent: 'comfortBonusB2b_assistanceBelgiumContent',
      content: 'comfortBonusB2b_content',
      infoLink: 'comfortBonusB2b_infoLink',
      levelOneContent: 'comfortBonusB2b_levelOneContent',
      levelOneTitle: 'comfortBonusB2b_levelOneTitle',
      levelTwoContent: 'comfortBonusB2b_levelTwoContent',
      levelTwoTitle: 'comfortBonusB2b_levelTwoTitle',
      levelZeroContent: 'comfortBonusB2b_levelZeroContent',
      title: 'comfortBonusB2b_title',
    },
  },
  MyEnecoInvoiceBillingDetails: {
    billingfrequency: {
      title: 'billingFrequency_title',
      updateLink: 'billingFrequency_updateLink',
    },
    duedateadvanceinvoices: {
      title: 'dueDateAdvanceInvoices_title',
      updateLink: 'dueDateAdvanceInvoices_updateLink',
    },
    paymentmethod: {
      title: 'paymentMethod_title',
      updateLink: 'paymentMethod_updateLink',
    },
  },
  MyEnecoProduct: {
    addproductcta: {
      link: 'addProductCta_link',
    },
    productcarddetails: {
      link: 'productCardDetails_link',
    },
  },
  MyEnecoProductDetails: {
    gridoperator: {
      title: 'gridOperator_title',
    },
    metercard: {
      title: 'meterCard_title',
    },
    tariffcard: {
      title: 'tariffCard_title',
    },
  },
  OfferStep: {
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      perMonthLabel: 'Costdetails_perMonthLabel',
      text: 'Costdetails_text',
      title: 'Costdetails_title',
      variableProductNotification: 'Costdetails_variableProductNotification',
    },
    electricitycostdetails: {
      deliveryCostsLabel: 'Electricitycostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Electricitycostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Electricitycostdetails_governmentLeviesLabel',
      redeliveryLabel: 'Electricitycostdetails_redeliveryLabel',
      standingChargeLabel: 'Electricitycostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Electricitycostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Electricitycostdetails_tariffLabel',
      taxBracket1Label: 'Electricitycostdetails_taxBracket1Label',
      taxBracket2Label: 'Electricitycostdetails_taxBracket2Label',
    },
    footer: {
      electricityHighLabel: 'footer_electricityHighLabel',
      electricityLabel: 'footer_electricityLabel',
      electricityLowLabel: 'footer_electricityLowLabel',
      gasLabel: 'footer_gasLabel',
      redeliveryLabel: 'footer_redeliveryLabel',
      warmthLabel: 'footer_warmthLabel',
    },
    gascostdetails: {
      deliveryCostsLabel: 'Gascostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Gascostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Gascostdetails_governmentLeviesLabel',
      standingChargeLabel: 'Gascostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Gascostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Gascostdetails_tariffLabel',
      taxBracket1Label: 'Gascostdetails_taxBracket1Label',
      taxBracket2Label: 'Gascostdetails_taxBracket2Label',
    },
    productdata: {
      perMonthLabel: 'ProductData_perMonthLabel',
      variableProductNotification: 'ProductData_variableProductNotification',
    },
    unitpricelabels: {
      electricityHighLabel: 'UnitPriceLabels_electricityHighLabel',
      electricityLabel: 'UnitPriceLabels_electricityLabel',
      electricityLowLabel: 'UnitPriceLabels_electricityLowLabel',
      gasLabel: 'UnitPriceLabels_gasLabel',
      redeliveryLabel: 'UnitPriceLabels_redeliveryLabel',
      warmthLabel: 'UnitPriceLabels_warmthLabel',
    },
    warmthcostdetails: {
      deliveryCostsLabel: 'WarmthCostDetails_deliveryCostsLabel',
      standingChargeLabel: 'WarmthCostDetails_standingChargeLabel',
      tariffLabel: 'WarmthCostDetails_tariffLabel',
    },
  },
  OrderManagement: {
    addressstep: {
      subTitle: 'addressStep_subTitle',
      title: 'addressStep_title',
    },
    assistanceservice: {
      description: 'assistanceService_description',
      disclaimerContent: 'assistanceService_disclaimerContent',
      errorText: 'assistanceService_errorText',
      noneOfAboveLabel: 'assistanceService_noneOfAboveLabel',
      subTitle: 'assistanceService_subTitle',
      title: 'assistanceService_title',
    },
    boilermaintenancestep: {
      description: 'boilerMaintenanceStep_description',
      disclaimerContent: 'boilerMaintenanceStep_disclaimerContent',
      errorText: 'boilerMaintenanceStep_errorText',
      noneOfAboveLabel: 'boilerMaintenanceStep_noneOfAboveLabel',
      subTitle: 'boilerMaintenanceStep_subTitle',
      title: 'boilerMaintenanceStep_title',
    },
    electricitydetailsstep: {
      eanCodeFormField: 'electricityDetailsStep_eanCodeFormField',
      eanCodeOfMeterList: 'electricityDetailsStep_eanCodeOfMeterList',
      editReasonList: 'electricityDetailsStep_editReasonList',
      meterInformationTitle: 'electricityDetailsStep_meterInformationTitle',
      meterNumberFormField: 'electricityDetailsStep_meterNumberFormField',
      meterReadingsKnownFormField: 'electricityDetailsStep_meterReadingsKnownFormField',
      meterTypeList: 'electricityDetailsStep_meterTypeList',
      startDateFormField: 'electricityDetailsStep_startDateFormField',
      startDateQuestionList: 'electricityDetailsStep_startDateQuestionList',
      subTitle: 'electricityDetailsStep_subTitle',
      title: 'electricityDetailsStep_title',
    },
    gasdetailsstep: {
      eanCodeFormField: 'gasDetailsStep_eanCodeFormField',
      eanCodeOfMeterList: 'gasDetailsStep_eanCodeOfMeterList',
      editReasonList: 'gasDetailsStep_editReasonList',
      meterInformationTitle: 'gasDetailsStep_meterInformationTitle',
      meterNumberFormField: 'gasDetailsStep_meterNumberFormField',
      meterReadingsKnownFormField: 'gasDetailsStep_meterReadingsKnownFormField',
      meterTypeList: 'gasDetailsStep_meterTypeList',
      startDateFormField: 'gasDetailsStep_startDateFormField',
      startDateQuestionList: 'gasDetailsStep_startDateQuestionList',
      subTitle: 'gasDetailsStep_subTitle',
      title: 'gasDetailsStep_title',
    },
    myenecoaccountstep: {
      errorText: 'myEnecoAccountStep_errorText',
      title: 'myEnecoAccountStep_title',
    },
    orderconfirmationstep: {
      bucketTitle: 'orderConfirmationStep_bucketTitle',
      subTitle: 'orderConfirmationStep_subTitle',
      title: 'orderConfirmationStep_title',
    },
    overviewstep: {
      bucketTitle: 'overviewStep_bucketTitle',
      errorNotification: 'overviewStep_errorNotification',
      subTitle: 'overviewStep_subTitle',
      title: 'overviewStep_title',
    },
    paymentmethodstep: {
      subTitle: 'paymentMethodStep_subTitle',
      title: 'paymentMethodStep_title',
    },
    personaldetailsstep: {
      subTitle: 'personalDetailsStep_subTitle',
      title: 'personalDetailsStep_title',
    },
    selectedproductsstep: {
      description: 'selectedProductsStep_description',
      errorNotification: 'selectedProductsStep_errorNotification',
      subTitle: 'selectedProductsStep_subTitle',
      title: 'selectedProductsStep_title',
    },
  },
  OverviewStep: {
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      text: 'Costdetails_text',
      title: 'Costdetails_title',
      variableProductNotification: 'Costdetails_variableProductNotification',
    },
    electricitycostdetails: {
      deliveryCostsLabel: 'Electricitycostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Electricitycostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Electricitycostdetails_governmentLeviesLabel',
      redeliveryLabel: 'Electricitycostdetails_redeliveryLabel',
      standingChargeLabel: 'Electricitycostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Electricitycostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Electricitycostdetails_tariffLabel',
      taxBracket1Label: 'Electricitycostdetails_taxBracket1Label',
      taxBracket2Label: 'Electricitycostdetails_taxBracket2Label',
    },
    footer: {
      redeliveryLabel: 'footer_redeliveryLabel',
    },
    gascostdetails: {
      deliveryCostsLabel: 'Gascostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Gascostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Gascostdetails_governmentLeviesLabel',
      standingChargeLabel: 'Gascostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Gascostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Gascostdetails_tariffLabel',
      taxBracket1Label: 'Gascostdetails_taxBracket1Label',
      taxBracket2Label: 'Gascostdetails_taxBracket2Label',
    },
    notifications: {
      variableProductNotification: 'Notifications_variableProductNotification',
    },
    warmthcostdetails: {
      deliveryCostsLabel: 'WarmthCostDetails_deliveryCostsLabel',
      standingChargeLabel: 'WarmthCostDetails_standingChargeLabel',
      tariffLabel: 'WarmthCostDetails_tariffLabel',
    },
  },
  OverviewStep2: {
    content: {
      title: 'Content_title',
    },
    footer: {
      electricityHighLabel: 'footer_electricityHighLabel',
      electricityLowLabel: 'footer_electricityLowLabel',
      gasLabel: 'footer_gasLabel',
    },
    pricebreakdownadditionalinfo: {
      title: 'priceBreakdownAdditionalInfo_title',
    },
    pricebreakdowncontent: {
      title: 'priceBreakdownContent_title',
    },
    pricebreakdowncostbreakdown: {
      title: 'priceBreakdownCostBreakdown_title',
    },
    pricebreakdownfixedcosts: {
      title: 'priceBreakdownFixedCosts_title',
    },
    pricebreakdowntariffs: {
      electricityHighLabel: 'priceBreakdownTariffs_electricityHighLabel',
      electricityLowLabel: 'priceBreakdownTariffs_electricityLowLabel',
      gasLabel: 'priceBreakdownTariffs_gasLabel',
      title: 'priceBreakdownTariffs_title',
    },
    pricebreakdowntotalcosts: {
      title: 'priceBreakdownTotalCosts_title',
    },
  },
  OxxioOfferStep: {
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      fixedCostsLabel: 'Costdetails_fixedCostsLabel',
      perMonthLabel: 'Costdetails_perMonthLabel',
      perYearLabel: 'Costdetails_perYearLabel',
      text: 'Costdetails_text',
      title: 'Costdetails_title',
      variableCostsLabel: 'Costdetails_variableCostsLabel',
      variableProductNotification: 'Costdetails_variableProductNotification',
    },
    fixedcostslabels: {
      fixedCostsLabel: 'Fixedcostslabels_fixedCostsLabel',
    },
    footer: {
      electricityHighLabel: 'footer_electricityHighLabel',
      electricityLowLabel: 'footer_electricityLowLabel',
      gasLabel: 'footer_gasLabel',
    },
    productdata: {
      perMonthLabel: 'ProductData_perMonthLabel',
      perYearLabel: 'ProductData_perYearLabel',
      variableProductNotification: 'ProductData_variableProductNotification',
    },
    variablecostslabels: {
      electricityHighLabel: 'Variablecostslabels_electricityHighLabel',
      electricityLowLabel: 'Variablecostslabels_electricityLowLabel',
      gasLabel: 'Variablecostslabels_gasLabel',
      variableCostsLabel: 'Variablecostslabels_variableCostsLabel',
    },
  },
  OxxioOverviewStep: {
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      fixedCostsLabel: 'Costdetails_fixedCostsLabel',
      perMonthLabel: 'Costdetails_perMonthLabel',
      text: 'Costdetails_text',
      title: 'Costdetails_title',
      variableCostsLabel: 'Costdetails_variableCostsLabel',
    },
    fixedcostslabels: {
      fixedCostsLabel: 'Fixedcostslabels_fixedCostsLabel',
    },
    productdata: {
      perMonthLabel: 'ProductData_perMonthLabel',
    },
    variablecostslabels: {
      variableCostsLabel: 'Variablecostslabels_variableCostsLabel',
    },
  },
  OxxioSummaryStep: {
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      fixedCostsLabel: 'Costdetails_fixedCostsLabel',
      text: 'Costdetails_text',
      title: 'Costdetails_title',
      variableCostsLabel: 'Costdetails_variableCostsLabel',
    },
    fixedcostslabels: {
      fixedCostsLabel: 'Fixedcostslabels_fixedCostsLabel',
    },
    paymentdetails: {
      title: 'Paymentdetails_title',
    },
    personaldetailsoverview: {
      title: 'Personaldetailsoverview_title',
    },
    productsoverview: {
      title: 'Productsoverview_title',
    },
    salesconditions: {
      title: 'Salesconditions_title',
    },
    unitpricelabels: {
      electricityHighLabel: 'UnitPriceLabels_electricityHighLabel',
      electricityLowLabel: 'UnitPriceLabels_electricityLowLabel',
      gasLabel: 'UnitPriceLabels_gasLabel',
    },
    variablecostslabels: {
      electricityHighLabel: 'Variablecostslabels_electricityHighLabel',
      electricityLowLabel: 'Variablecostslabels_electricityLowLabel',
      gasLabel: 'Variablecostslabels_gasLabel',
      variableCostsLabel: 'Variablecostslabels_variableCostsLabel',
    },
  },
  PaymentArrangementConfirmStep: {
    content: {
      content: 'Content_content',
    },
    header: {
      title: 'Header_title',
    },
    infonotification: {
      description: 'Infonotification_description',
    },
    invoicescard: {
      title: 'Invoicescard_title',
    },
    paymentarrangementcard: {
      description: 'Paymentarrangementcard_description',
      title: 'Paymentarrangementcard_title',
    },
    startdatecard: {
      content: 'Startdatecard_content',
      title: 'Startdatecard_title',
    },
    successfeedback: {
      title: 'Successfeedback_title',
    },
    terminterval: {
      description: 'Terminterval_description',
      title: 'Terminterval_title',
    },
  },
  PaymentArrangementHeader: {
    closedialog: {
      title: 'Closedialog_title',
    },
    proposaloverviewstep: {
      title: 'Proposaloverviewstep_title',
    },
  },
  PaymentArrangementInvoicesStep: {
    formfeedback: {
      label: 'Formfeedback_label',
    },
    paymentarrangementtotal: {
      label: 'Paymentarrangementtotal_label',
    },
  },
  PaymentArrangementProposalPlanStep: {
    paymentarrangement: {
      description: 'paymentArrangement_description',
      title: 'paymentArrangement_title',
    },
    proposaltableform: {
      description: 'proposalTableForm_description',
      title: 'proposalTableForm_title',
    },
    termsandconditions: {
      description: 'termsAndConditions_description',
    },
  },
  PaymentMethods: {
    onetimecost: {
      buttonLabel: 'oneTimeCost_buttonLabel',
      content: 'oneTimeCost_content',
    },
    rental: {
      buttonLabel: 'rental_buttonLabel',
      content: 'rental_content',
    },
  },
  PaymentPlan: {
    directdebit: {
      bankAccountNumberTitle: 'directDebit_bankAccountNumberTitle',
      bankAccountNumberUnknownText: 'directDebit_bankAccountNumberUnknownText',
      description: 'directDebit_description',
      title: 'directDebit_title',
    },
    header: {
      title: 'Header_title',
    },
    manualpayment: {
      bankAccountNumberTitle: 'manualPayment_bankAccountNumberTitle',
      bankAccountNumberUnknownText: 'manualPayment_bankAccountNumberUnknownText',
      description: 'manualPayment_description',
      title: 'manualPayment_title',
    },
  },
  PaymentTransactionStatus: {
    cancelled: {
      CancelledDescription: 'cancelledDescription',
      CancelledTitle: 'cancelledTitle',
    },
    error: {
      ErrorDescription: 'errorDescription',
      ErrorTitle: 'errorTitle',
    },
    open: {
      OpenDescription: 'openDescription',
      OpenTitle: 'openTitle',
    },
    succes: {
      SuccessDescription: 'successDescription',
      SuccessTitle: 'successTitle',
    },
  },
  PaymentTransactionStatusV2: {
    cancelled: {
      CancelledDescription: 'cancelledDescription',
      CancelledTitle: 'cancelledTitle',
    },
    error: {
      ErrorDescription: 'errorDescription',
      ErrorTitle: 'errorTitle',
    },
    open: {
      OpenDescription: 'openDescription',
      OpenTitle: 'openTitle',
    },
    succes: {
      SuccessDescription: 'successDescription',
      SuccessTitle: 'successTitle',
    },
  },
  PriceSimulation: {
    actionselectionstep: {
      explanationDescription: 'actionSelectionStep_explanationDescription',
      explanationTitle: 'actionSelectionStep_explanationTitle',
      navigationTitle: 'actionSelectionStep_navigationTitle',
      title: 'actionSelectionStep_title',
    },
    addresstypeselectionstep: {
      explanationDescription: 'addressTypeSelectionStep_explanationDescription',
      explanationTitle: 'addressTypeSelectionStep_explanationTitle',
      navigationTitle: 'addressTypeSelectionStep_navigationTitle',
      title: 'addressTypeSelectionStep_title',
    },
    bidirectionalmeterstep: {
      compensationOptionsList: 'biDirectionalMeterStep_compensationOptionsList',
      explanationDescription: 'biDirectionalMeterStep_explanationDescription',
      explanationTitle: 'biDirectionalMeterStep_explanationTitle',
      subTitle: 'biDirectionalMeterStep_subTitle',
      title: 'biDirectionalMeterStep_title',
    },
    capacityratestep: {
      description: 'capacityRateStep_description',
      explanationDescription: 'capacityRateStep_explanationDescription',
      explanationTitle: 'capacityRateStep_explanationTitle',
      subTitle: 'capacityRateStep_subTitle',
      title: 'capacityRateStep_title',
    },
    currentenergyconsumptionquestionstep: {
      errorNotification: 'currentEnergyConsumptionQuestionStep_errorNotification',
      explanationDescription: 'currentEnergyConsumptionQuestionStep_explanationDescription',
      explanationTitle: 'currentEnergyConsumptionQuestionStep_explanationTitle',
      subTitle: 'currentEnergyConsumptionQuestionStep_subTitle',
      title: 'currentEnergyConsumptionQuestionStep_title',
    },
    currentheatinginstallationtypestep: {
      explanationDescription: 'currentHeatingInstallationTypeStep_explanationDescription',
      explanationTitle: 'currentHeatingInstallationTypeStep_explanationTitle',
      subTitle: 'currentHeatingInstallationTypeStep_subTitle',
      title: 'currentHeatingInstallationTypeStep_title',
    },
    customerquestionstep: {
      explanationDescription: 'customerQuestionStep_explanationDescription',
      explanationTitle: 'customerQuestionStep_explanationTitle',
      navigationTitle: 'customerQuestionStep_navigationTitle',
      title: 'customerQuestionStep_title',
    },
    digitalmeterquestionstep: {
      explanationDescription: 'digitalMeterQuestionStep_explanationDescription',
      explanationText: 'digitalMeterQuestionStep_explanationText',
      explanationTitle: 'digitalMeterQuestionStep_explanationTitle',
      subTitle: 'digitalMeterQuestionStep_subTitle',
      title: 'digitalMeterQuestionStep_title',
    },
    digitalmetertypestep: {
      explanationDescription: 'digitalMeterTypeStep_explanationDescription',
      explanationText: 'digitalMeterTypeStep_explanationText',
      explanationTitle: 'digitalMeterTypeStep_explanationTitle',
      subTitle: 'digitalMeterTypeStep_subTitle',
      title: 'digitalMeterTypeStep_title',
    },
    electricityconsumptionstep: {
      description: 'electricityConsumptionStep_description',
      explanationDescription: 'electricityConsumptionStep_explanationDescription',
      explanationTitle: 'electricityConsumptionStep_explanationTitle',
      maxConsumptionUsageDescription: 'electricityConsumptionStep_maxConsumptionUsageDescription',
      subTitle: 'electricityConsumptionStep_subTitle',
      title: 'electricityConsumptionStep_title',
    },
    energytypeselectionstep: {
      errorNotification: 'energyTypeSelectionStep_errorNotification',
      explanationDescription: 'energyTypeSelectionStep_explanationDescription',
      explanationTitle: 'energyTypeSelectionStep_explanationTitle',
      subTitle: 'energyTypeSelectionStep_subTitle',
      title: 'energyTypeSelectionStep_title',
    },
    gasconsumptionstep: {
      description: 'gasConsumptionStep_description',
      explanationDescription: 'gasConsumptionStep_explanationDescription',
      explanationTitle: 'gasConsumptionStep_explanationTitle',
      maxConsumptionUsageDescription: 'gasConsumptionStep_maxConsumptionUsageDescription',
      subTitle: 'gasConsumptionStep_subTitle',
      title: 'gasConsumptionStep_title',
    },
    installationtypestep: {
      explanationDescription: 'installationTypeStep_explanationDescription',
      explanationTitle: 'installationTypeStep_explanationTitle',
      subTitle: 'installationTypeStep_subTitle',
      title: 'installationTypeStep_title',
    },
    numberofpeopleinpropertystep: {
      explanationDescription: 'numberOfPeopleInPropertyStep_explanationDescription',
      explanationTitle: 'numberOfPeopleInPropertyStep_explanationTitle',
      subTitle: 'numberOfPeopleInPropertyStep_subTitle',
      title: 'numberOfPeopleInPropertyStep_title',
    },
    postalcodeselectionstep: {
      explanationDescription: 'postalCodeSelectionStep_explanationDescription',
      explanationTitle: 'postalCodeSelectionStep_explanationTitle',
      subTitle: 'postalCodeSelectionStep_subTitle',
      title: 'postalCodeSelectionStep_title',
    },
    propertytypestep: {
      explanationDescription: 'propertyTypeStep_explanationDescription',
      explanationTitle: 'propertyTypeStep_explanationTitle',
      subTitle: 'propertyTypeStep_subTitle',
      title: 'propertyTypeStep_title',
    },
    proposalstep: {
      description: 'proposalStep_description',
      explanationDescription: 'proposalStep_explanationDescription',
      explanationTitle: 'proposalStep_explanationTitle',
      subTitle: 'proposalStep_subTitle',
      title: 'proposalStep_title',
    },
    solarinstallationdatestep: {
      compensationOptionsList: 'solarInstallationDateStep_compensationOptionsList',
      explanationDescription: 'solarInstallationDateStep_explanationDescription',
      explanationTitle: 'solarInstallationDateStep_explanationTitle',
      subTitle: 'solarInstallationDateStep_subTitle',
      title: 'solarInstallationDateStep_title',
    },
    solarpanelsenergyreturnstep: {
      description: 'solarPanelsEnergyReturnStep_description',
      explanationDescription: 'solarPanelsEnergyReturnStep_explanationDescription',
      explanationTitle: 'solarPanelsEnergyReturnStep_explanationTitle',
      subTitle: 'solarPanelsEnergyReturnStep_subTitle',
      title: 'solarPanelsEnergyReturnStep_title',
    },
    stepindicator: {
      explanationDescription: 'stepIndicator_explanationDescription',
      explanationTitle: 'stepIndicator_explanationTitle',
    },
    summarycontractcard: {
      explanationDescription: 'summaryContractCard_explanationDescription',
      explanationTitle: 'summaryContractCard_explanationTitle',
    },
    summarystep: {
      description: 'summaryStep_description',
      errorNotification: 'summaryStep_errorNotification',
      subTitle: 'summaryStep_subTitle',
      title: 'summaryStep_title',
    },
  },
  ProductSwitch: {
    electricitystep: {
      cancelButtonText: 'electricityStep_cancelButtonText',
      continueButtonText: 'electricityStep_continueButtonText',
      continueWithoutChangesButtonText: 'electricityStep_continueWithoutChangesButtonText',
      currentRateLinkLabel: 'electricityStep_currentRateLinkLabel',
      productSwitchDescription: 'electricityStep_productSwitchDescription',
      productsLink: 'electricityStep_productsLink',
      promoDisclaimerText: 'electricityStep_promoDisclaimerText',
      subTitle: 'electricityStep_subTitle',
      title: 'electricityStep_title',
      upsellTitle: 'electricityStep_upsellTitle',
    },
    gasstep: {
      cancelButtonText: 'gasStep_cancelButtonText',
      continueButtonText: 'gasStep_continueButtonText',
      continueWithoutChangesButtonText: 'gasStep_continueWithoutChangesButtonText',
      currentRateLinkLabel: 'gasStep_currentRateLinkLabel',
      productSwitchDescription: 'gasStep_productSwitchDescription',
      productsLink: 'gasStep_productsLink',
      promoDisclaimerText: 'gasStep_promoDisclaimerText',
      subTitle: 'gasStep_subTitle',
      title: 'gasStep_title',
      upsellTitle: 'gasStep_upsellTitle',
    },
    mailconfirmation: {
      title: 'mailConfirmation_title',
    },
    navigation: {
      errorNotification: 'navigation_errorNotification',
      successNotification: 'navigation_successNotification',
    },
    productproposal: {
      annualAmountLabel: 'productProposal_annualAmountLabel',
      rateCardLinkLabel: 'productProposal_rateCardLinkLabel',
    },
    summaryelectricitycard: {
      annualAmountDescription: 'summaryElectricityCard_annualAmountDescription',
      annualAmountLabel: 'summaryElectricityCard_annualAmountLabel',
      eanLabel: 'summaryElectricityCard_eanLabel',
      editButtonLabel: 'summaryElectricityCard_editButtonLabel',
      productNameLabel: 'summaryElectricityCard_productNameLabel',
      rateCardLabel: 'summaryElectricityCard_rateCardLabel',
      rateCardLink: 'summaryElectricityCard_rateCardLink',
      rateCardLinkLabel: 'summaryElectricityCard_rateCardLinkLabel',
      title: 'summaryElectricityCard_title',
    },
    summarygascard: {
      annualAmountDescription: 'summaryGasCard_annualAmountDescription',
      annualAmountLabel: 'summaryGasCard_annualAmountLabel',
      eanLabel: 'summaryGasCard_eanLabel',
      editButtonLabel: 'summaryGasCard_editButtonLabel',
      productNameLabel: 'summaryGasCard_productNameLabel',
      rateCardLabel: 'summaryGasCard_rateCardLabel',
      rateCardLink: 'summaryGasCard_rateCardLink',
      rateCardLinkLabel: 'summaryGasCard_rateCardLinkLabel',
      title: 'summaryGasCard_title',
    },
    summarystep: {
      errorNotification: 'summaryStep_errorNotification',
      successNotification: 'summaryStep_successNotification',
      title: 'summaryStep_title',
    },
  },
  ProfileManagementLoginDetails: {
    itsmelinked: {
      ItsmeLinkedFailedContent: 'itsmeLinkedFailedContent',
      ItsmeLinkedFailedTitle: 'itsmeLinkedFailedTitle',
      ItsmeLinkedSuccessContent: 'itsmeLinkedSuccessContent',
      ItsmeLinkedSuccessTitle: 'itsmeLinkedSuccessTitle',
      ItsmeOtherUserAlreadyLinkedNotification: 'itsmeOtherUserAlreadyLinkedNotification',
    },
    itsmeunlinked: {
      ItsmeUnlinkedFailedNotification: 'itsmeUnlinkedFailedNotification',
      ItsmeUnlinkedSuccessNotification: 'itsmeUnlinkedSuccessNotification',
    },
  },
  Rectification: {
    chooseconnectionaddressstep: {
      subTitle: 'chooseConnectionAddressStep_subTitle',
      title: 'chooseConnectionAddressStep_title',
    },
    chooseeancodestep: {
      electricityLabel: 'chooseEanCodeStep_electricityLabel',
      gasLabel: 'chooseEanCodeStep_gasLabel',
      subTitle: 'chooseEanCodeStep_subTitle',
      title: 'chooseEanCodeStep_title',
    },
    correctionnotpossiblestopstep: {
      description: 'correctionNotPossibleStopStep_description',
      subTitle: 'correctionNotPossibleStopStep_subTitle',
      title: 'correctionNotPossibleStopStep_title',
    },
    deviationmeasuredstep: {
      description: 'deviationMeasuredStep_description',
      subTitle: 'deviationMeasuredStep_subTitle',
      title: 'deviationMeasuredStep_title',
    },
    disputemeterreadingsstep: {
      description: 'disputeMeterReadingsStep_description',
      subTitle: 'disputeMeterReadingsStep_subTitle',
      title: 'disputeMeterReadingsStep_title',
    },
    entermeterreadingsstep: {
      title: 'enterMeterReadingsStep_title',
    },
    meterreadingdatestep: {
      addressLabel: 'meterReadingDateStep_addressLabel',
      dayLabel: 'meterReadingDateStep_dayLabel',
      eanCodeLabel: 'meterReadingDateStep_eanCodeLabel',
      subTitle: 'meterReadingDateStep_subTitle',
      title: 'meterReadingDateStep_title',
    },
    nodeviationflowstopstep: {
      subTitle: 'noDeviationFlowStopStep_subTitle',
      title: 'noDeviationFlowStopStep_title',
    },
    successscreenstep: {
      errorNotification: 'successScreenStep_errorNotification',
      successNotification: 'successScreenStep_successNotification',
      title: 'successScreenStep_title',
    },
    summaryproductcard: {
      addressLabel: 'summaryProductCard_addressLabel',
      dayLabel: 'summaryProductCard_dayLabel',
      eanCodeLabel: 'summaryProductCard_eanCodeLabel',
      electricityLabel: 'summaryProductCard_electricityLabel',
      gasLabel: 'summaryProductCard_gasLabel',
      title: 'summaryProductCard_title',
    },
    summarystep: {
      errorNotification: 'summaryStep_errorNotification',
      successNotification: 'summaryStep_successNotification',
      title: 'summaryStep_title',
    },
  },
  RegistrationAccountCreate: {
    canregisteraddress: {
      continueButtonText: 'CanRegisterAddress_continueButtonText',
      introductionText: 'CanRegisterAddress_introductionText',
      modalDialog: 'CanRegisterAddress_modalDialog',
      title: 'CanRegisterAddress_title',
    },
    canregistercustomerid: {
      backLinkText: 'CanRegisterCustomerID_backLinkText',
      continueButtonText: 'CanRegisterCustomerID_continueButtonText',
      introductionText: 'CanRegisterCustomerID_introductionText',
      modalDialog: 'CanRegisterCustomerID_modalDialog',
      title: 'CanRegisterCustomerID_title',
    },
    header: {
      title: 'header_title',
    },
    registerorgemail: {
      backLinkText: 'RegisterOrgEmail_backLinkText',
      confirmButtonText: 'RegisterOrgEmail_confirmButtonText',
      conflictErrorNotification: 'RegisterOrgEmail_conflictErrorNotification',
      emailFormField: 'RegisterOrgEmail_emailFormField',
      modalDialog: 'RegisterOrgEmail_modalDialog',
      technicalErrorNotificationField: 'RegisterOrgEmail_technicalErrorNotificationField',
      title: 'RegisterOrgEmail_title',
    },
    registerorgpassword: {
      confirmButtonText: 'RegisterOrgPassword_confirmButtonText',
      introductionText: 'RegisterOrgPassword_introductionText',
      passwordFormField: 'RegisterOrgPassword_passwordFormField',
      title: 'RegisterOrgPassword_title',
    },
    registerperson: {
      backLinkText: 'RegisterPerson_backLinkText',
      conflictErrorNotification: 'RegisterPerson_conflictErrorNotification',
      continueButtonText: 'RegisterPerson_continueButtonText',
      emailFormField: 'RegisterPerson_emailFormField',
      introductionText: 'RegisterPerson_introductionText',
      modalDialog: 'RegisterPerson_modalDialog',
      passwordFormField: 'RegisterPerson_passwordFormField',
      technicalErrorNotificationField: 'RegisterPerson_technicalErrorNotificationField',
      title: 'RegisterPerson_title',
    },
    registersuccess: {
      introductionText: 'RegisterSuccess_introductionText',
      title: 'RegisterSuccess_title',
    },
  },
  RegistrationAccountReset: {
    canregisteraddress: {
      continueButtonText: 'CanRegisterAddress_continueButtonText',
      introductionText: 'CanRegisterAddress_introductionText',
      modalDialog: 'CanRegisterAddress_modalDialog',
      title: 'CanRegisterAddress_title',
    },
    canregistercustomerid: {
      backLinkText: 'CanRegisterCustomerID_backLinkText',
      continueButtonText: 'CanRegisterCustomerID_continueButtonText',
      introductionText: 'CanRegisterCustomerID_introductionText',
      modalDialog: 'CanRegisterCustomerID_modalDialog',
      title: 'CanRegisterCustomerID_title',
    },
    header: {
      title: 'header_title',
    },
    registerorgemail: {
      backLinkText: 'RegisterOrgEmail_backLinkText',
      confirmButtonText: 'RegisterOrgEmail_confirmButtonText',
      conflictErrorNotification: 'RegisterOrgEmail_conflictErrorNotification',
      emailFormField: 'RegisterOrgEmail_emailFormField',
      modalDialog: 'RegisterOrgEmail_modalDialog',
      technicalErrorNotificationField: 'RegisterOrgEmail_technicalErrorNotificationField',
      title: 'RegisterOrgEmail_title',
    },
    registerorgpassword: {
      confirmButtonText: 'RegisterOrgPassword_confirmButtonText',
      introductionText: 'RegisterOrgPassword_introductionText',
      passwordFormField: 'RegisterOrgPassword_passwordFormField',
      title: 'RegisterOrgPassword_title',
    },
    registerperson: {
      backLinkText: 'RegisterPerson_backLinkText',
      conflictErrorNotification: 'RegisterPerson_conflictErrorNotification',
      continueButtonText: 'RegisterPerson_continueButtonText',
      emailFormField: 'RegisterPerson_emailFormField',
      introductionText: 'RegisterPerson_introductionText',
      modalDialog: 'RegisterPerson_modalDialog',
      passwordFormField: 'RegisterPerson_passwordFormField',
      technicalErrorNotificationField: 'RegisterPerson_technicalErrorNotificationField',
      title: 'RegisterPerson_title',
    },
    registersuccess: {
      introductionText: 'RegisterSuccess_introductionText',
      title: 'RegisterSuccess_title',
    },
  },
  RelocationConfirmationStep: {
    content: {
      content: 'content_content',
    },
    currentaddress: {
      label: 'currentAddress_label',
    },
    footer: {
      text: 'footer_text',
    },
    formfeedbackerror: {
      content: 'formFeedbackError_content',
      title: 'formFeedbackError_title',
    },
    formfeedbacksuccess: {
      text: 'formFeedbackSuccess_text',
      title: 'formFeedbackSuccess_title',
    },
    formputmoveindateinvalid: {
      content: 'formPutMoveInDateInvalid_content',
      title: 'formPutMoveInDateInvalid_title',
    },
    formputmoveoutdateinvalid: {
      content: 'formPutMoveOutDateInvalid_content',
      title: 'formPutMoveOutDateInvalid_title',
    },
    formputrelocationdisallowed: {
      content: 'formPutRelocationDisallowed_content',
      title: 'formPutRelocationDisallowed_title',
    },
    header: {
      title: 'header_title',
    },
    moveindate: {
      label: 'moveInDate_label',
    },
    moveoutdate: {
      label: 'moveOutDate_label',
    },
    newaddress: {
      label: 'newAddress_label',
    },
    products: {
      title: 'products_title',
    },
    unknowndate: {
      text: 'unknownDate_text',
    },
  },
  RelocationContactDetailsStep: {
    emailaddress: {
      formField: 'Emailaddress_formField',
    },
    mobilephonenumber: {
      formField: 'mobilePhoneNumber_formField',
    },
    phonenumber: {
      formField: 'phoneNumber_formField',
    },
  },
  RelocationDisallowed: {
    alreadyhasrelocation: {
      description: 'alreadyHasRelocation_description',
      link: 'alreadyHasRelocation_link',
      title: 'alreadyHasRelocation_title',
    },
    contractalreadycancelled: {
      description: 'contractAlreadyCancelled_description',
      link: 'contractAlreadyCancelled_link',
      title: 'contractAlreadyCancelled_title',
    },
    other: {
      description: 'other_description',
      link: 'other_link',
      title: 'other_title',
    },
    productscantbemovedonline: {
      description: 'productsCantBeMovedOnline_description',
      link: 'productsCantBeMovedOnline_link',
      title: 'productsCantBeMovedOnline_title',
    },
  },
  RelocationMoveInCard: {
    moveindate: {
      label: 'moveInDate_label',
    },
    newaddress: {
      label: 'newAddress_label',
    },
  },
  RelocationMoveInForm: {
    feedbackerror: {
      content: 'feedbackError_content',
      title: 'feedbackError_title',
    },
    header: {
      title: 'header_title',
    },
    patchnorelocationsfound: {
      content: 'patchNoRelocationsFound_content',
      title: 'patchNoRelocationsFound_title',
    },
    patchnorelocationwithid: {
      content: 'patchNoRelocationWithId_content',
      title: 'patchNoRelocationWithId_title',
    },
    patchrelocationdateissameasoldrelocationdate: {
      content: 'patchRelocationDateIsSameAsOldRelocationDate_content',
      title: 'patchRelocationDateIsSameAsOldRelocationDate_title',
    },
    patchrelocationdatenotwithinrange: {
      content: 'patchRelocationDateNotWithinRange_content',
      title: 'patchRelocationDateNotWithinRange_title',
    },
    patchrelocationissetfortoday: {
      content: 'patchRelocationIsSetForToday_content',
      title: 'patchRelocationIsSetForToday_title',
    },
    successnotification: {
      title: 'successNotification_title',
    },
  },
  RelocationMoveInStep: {
    discontinuedproductelectricity: {
      text: 'discontinuedProductElectricity_text',
    },
    discontinuedproductgas: {
      text: 'discontinuedProductGas_text',
    },
    isotherresidence: {
      formField: 'isOtherResidence_formField',
      noLabel: 'isOtherResidence_noLabel',
      yesLabel: 'isOtherResidence_yesLabel',
    },
    isresidence: {
      formField: 'isResidence_formField',
      noLabel: 'isResidence_noLabel',
      yesLabel: 'isResidence_yesLabel',
    },
    keydatenewaddress: {
      formField: 'keyDateNewAddress_formField',
    },
    newaddress: {
      label: 'newAddress_label',
    },
    products: {
      label: 'products_label',
    },
  },
  RelocationMoveOutCard: {
    changenotallowednotification: {
      text: 'changeNotAllowedNotification_text',
      title: 'changeNotAllowedNotification_title',
    },
    enddate: {
      label: 'endDate_label',
    },
    header: {
      title: 'header_title',
    },
    oldaddress: {
      label: 'oldAddress_label',
    },
    unknowndate: {
      text: 'unknownDate_text',
    },
  },
  RelocationMoveOutForm: {
    changenotallowednotification: {
      text: 'changeNotAllowedNotification_text',
      title: 'changeNotAllowedNotification_title',
    },
    header: {
      title: 'header_title',
    },
    putmoveoutdateinvalid: {
      content: 'putMoveOutDateInvalid_content',
      title: 'putMoveOutDateInvalid_title',
    },
    putrelocationdisallowed: {
      content: 'putRelocationDisallowed_content',
      title: 'putRelocationDisallowed_title',
    },
    successnotification: {
      text: 'successNotification_text',
      title: 'successNotification_title',
    },
  },
  RelocationMoveOutStep: {
    isunknowndate: {
      formField: 'isUnknownDate_formField',
    },
    keydatecurrentaddress: {
      formField: 'keyDateCurrentAddress_formField',
    },
  },
  RentalDevicesDetectionStep: {
    choices: {
      title: 'Choices_title',
    },
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    norentaldevicesfoundcontent: {
      text: 'noRentalDevicesFoundContent_text',
      title: 'noRentalDevicesFoundContent_title',
    },
  },
  RentalDevicesOverviewStep: {
    content: {
      title: 'Content_title',
    },
    productsoverview: {
      title: 'Productsoverview_title',
    },
  },
  RentalDevicesSummaryStep: {
    content: {
      title: 'Content_title',
    },
    paymentdetails: {
      title: 'Paymentdetails_title',
    },
    personaldetailsoverview: {
      title: 'Personaldetailsoverview_title',
    },
    productsoverview: {
      title: 'Productsoverview_title',
    },
  },
  SMEOfferStep: {
    footer: {
      electricityHighLabel: 'footer_electricityHighLabel',
      electricityLabel: 'footer_electricityLabel',
      electricityLowLabel: 'footer_electricityLowLabel',
      gasLabel: 'footer_gasLabel',
      redeliveryLabel: 'footer_redeliveryLabel',
      warmthLabel: 'footer_warmthLabel',
    },
    unitpricelabels: {
      electricityHighLabel: 'UnitPriceLabels_electricityHighLabel',
      electricityLabel: 'UnitPriceLabels_electricityLabel',
      electricityLowLabel: 'UnitPriceLabels_electricityLowLabel',
      gasLabel: 'UnitPriceLabels_gasLabel',
      redeliveryLabel: 'UnitPriceLabels_redeliveryLabel',
      warmthLabel: 'UnitPriceLabels_warmthLabel',
    },
  },
  SMESummaryStep: {
    companydetailsoverview: {
      editDetailsLabel: 'companyDetailsOverview_editDetailsLabel',
      title: 'companyDetailsOverview_title',
    },
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      text: 'Costdetails_text',
      title: 'Costdetails_title',
    },
    electricitycostdetails: {
      deliveryCostsLabel: 'Electricitycostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Electricitycostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Electricitycostdetails_governmentLeviesLabel',
      redeliveryLabel: 'Electricitycostdetails_redeliveryLabel',
      standingChargeLabel: 'Electricitycostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Electricitycostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Electricitycostdetails_tariffLabel',
      taxBracket1Label: 'Electricitycostdetails_taxBracket1Label',
      taxBracket2Label: 'Electricitycostdetails_taxBracket2Label',
    },
    gascostdetails: {
      deliveryCostsLabel: 'Gascostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Gascostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Gascostdetails_governmentLeviesLabel',
      standingChargeLabel: 'Gascostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Gascostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Gascostdetails_tariffLabel',
      taxBracket1Label: 'Gascostdetails_taxBracket1Label',
      taxBracket2Label: 'Gascostdetails_taxBracket2Label',
    },
    paymentdetails: {
      title: 'Paymentdetails_title',
    },
    personaldetailsoverview: {
      editDetailsLabel: 'Personaldetailsoverview_editDetailsLabel',
      title: 'Personaldetailsoverview_title',
    },
    productsoverview: {
      title: 'Productsoverview_title',
    },
    salesconditions: {
      title: 'Salesconditions_title',
    },
    unitpricelabels: {
      redeliveryLabel: 'UnitPriceLabels_redeliveryLabel',
    },
    warmthcostdetails: {
      deliveryCostsLabel: 'WarmthCostDetails_deliveryCostsLabel',
      standingChargeLabel: 'WarmthCostDetails_standingChargeLabel',
      tariffLabel: 'WarmthCostDetails_tariffLabel',
    },
  },
  ServiceGemakFlowPersonalDetailsStep: {
    content: {
      text: 'content_text',
      title: 'content_title',
    },
    login: {
      text: 'login_text',
      title: 'login_title',
    },
  },
  SmeCompanyDetailsStep: {
    contactdetails: {
      text: 'contactDetails_text',
    },
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    optin: {
      title: 'optIn_title',
    },
  },
  SmeOfferStep: {
    content: {
      title: 'content_title',
    },
    costdetails: {
      perMonthLabel: 'costDetails_perMonthLabel',
      title: 'costDetails_title',
    },
    costdetailsexplanation: {
      title: 'costDetailsExplanation_title',
    },
    electricitycostdetails: {
      deliveryCostsLabel: 'electricityCostDetails_deliveryCostsLabel',
      energyTaxLabel: 'electricityCostDetails_energyTaxLabel',
      governmentLeviesLabel: 'electricityCostDetails_governmentLeviesLabel',
      redeliveryLabel: 'electricityCostDetails_redeliveryLabel',
      standingChargeLabel: 'electricityCostDetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'electricityCostDetails_storageSustainableEnergyLabel',
      tariffLabel: 'electricityCostDetails_tariffLabel',
      taxBracket1Label: 'electricityCostDetails_taxBracket1Label',
      taxBracket2Label: 'electricityCostDetails_taxBracket2Label',
    },
    footer: {
      electricityHighLabel: 'footer_electricityHighLabel',
      electricityLabel: 'footer_electricityLabel',
      electricityLowLabel: 'footer_electricityLowLabel',
      gasLabel: 'footer_gasLabel',
      redeliveryLabel: 'footer_redeliveryLabel',
      warmthLabel: 'footer_warmthLabel',
    },
    gascostdetails: {
      deliveryCostsLabel: 'gasCostDetails_deliveryCostsLabel',
      energyTaxLabel: 'gasCostDetails_energyTaxLabel',
      governmentLeviesLabel: 'gasCostDetails_governmentLeviesLabel',
      standingChargeLabel: 'gasCostDetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'gasCostDetails_storageSustainableEnergyLabel',
      tariffLabel: 'gasCostDetails_tariffLabel',
      taxBracket1Label: 'gasCostDetails_taxBracket1Label',
      taxBracket2Label: 'gasCostDetails_taxBracket2Label',
    },
    productdata: {
      perMonthLabel: 'productData_perMonthLabel',
    },
    unitpricelabels: {
      electricityHighLabel: 'unitPriceLabels_electricityHighLabel',
      electricityLabel: 'unitPriceLabels_electricityLabel',
      electricityLowLabel: 'unitPriceLabels_electricityLowLabel',
      gasLabel: 'unitPriceLabels_gasLabel',
      redeliveryLabel: 'unitPriceLabels_redeliveryLabel',
      warmthLabel: 'unitPriceLabels_warmthLabel',
    },
    warmthcostdetails: {
      deliveryCostsLabel: 'warmthCostDetails_deliveryCostsLabel',
      standingChargeLabel: 'warmthCostDetails_standingChargeLabel',
      tariffLabel: 'warmthCostDetails_tariffLabel',
    },
  },
  SmeSolarPanelsStep: {
    content: {
      title: 'content_title',
    },
    redelivery: {
      title: 'redelivery_title',
    },
  },
  SolarBoilerLeadFlowContactDetailsStep: {
    content: {
      title: 'content_title',
    },
    optin: {
      title: 'optIn_title',
    },
  },
  SummaryStep: {
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      text: 'Costdetails_text',
      title: 'Costdetails_title',
    },
    electricitycostdetails: {
      deliveryCostsLabel: 'Electricitycostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Electricitycostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Electricitycostdetails_governmentLeviesLabel',
      redeliveryLabel: 'Electricitycostdetails_redeliveryLabel',
      standingChargeLabel: 'Electricitycostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Electricitycostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Electricitycostdetails_tariffLabel',
      taxBracket1Label: 'Electricitycostdetails_taxBracket1Label',
      taxBracket2Label: 'Electricitycostdetails_taxBracket2Label',
    },
    gascostdetails: {
      deliveryCostsLabel: 'Gascostdetails_deliveryCostsLabel',
      energyTaxLabel: 'Gascostdetails_energyTaxLabel',
      governmentLeviesLabel: 'Gascostdetails_governmentLeviesLabel',
      standingChargeLabel: 'Gascostdetails_standingChargeLabel',
      storageSustainableEnergyLabel: 'Gascostdetails_storageSustainableEnergyLabel',
      tariffLabel: 'Gascostdetails_tariffLabel',
      taxBracket1Label: 'Gascostdetails_taxBracket1Label',
      taxBracket2Label: 'Gascostdetails_taxBracket2Label',
    },
    paymentdetails: {
      title: 'Paymentdetails_title',
    },
    personaldetailsoverview: {
      title: 'Personaldetailsoverview_title',
    },
    productsoverview: {
      title: 'Productsoverview_title',
    },
    salesconditions: {
      title: 'Salesconditions_title',
    },
    unitpricelabels: {
      redeliveryLabel: 'UnitPriceLabels_redeliveryLabel',
    },
    warmthcostdetails: {
      deliveryCostsLabel: 'WarmthCostDetails_deliveryCostsLabel',
      standingChargeLabel: 'WarmthCostDetails_standingChargeLabel',
      tariffLabel: 'WarmthCostDetails_tariffLabel',
    },
  },
  ThermostatFlowOfferStep: {
    content: {
      text: 'content_text',
      title: 'content_title',
    },
    productdetails: {
      text: 'productDetails_text',
      title: 'productDetails_title',
    },
  },
  ThermostatFlowOverviewStep: {
    content: {
      title: 'content_title',
    },
    personaldetails: {
      title: 'personalDetails_title',
    },
    productdetails: {
      title: 'productDetails_title',
    },
  },
  ToonOfferStep: {
    content: {
      text: 'Content_text',
      title: 'Content_title',
    },
    costdetails: {
      text: 'costDetails_text',
      title: 'costDetails_title',
    },
    productdata: {
      ToonProductsList: 'toonProductsList',
    },
  },
  ToonOverviewStep: {
    productdata: {
      ToonProductsList: 'toonProductsList',
    },
  },
  ToonSummaryStep: {
    content: {
      title: 'Content_title',
    },
    paymentdetails: {
      title: 'paymentDetails_title',
    },
    personaldetailsoverview: {
      title: 'personalDetailsOverview_title',
    },
    productdata: {
      ToonProductsList: 'toonProductsList',
    },
    productsoverview: {
      title: 'productsOverview_title',
    },
  },
  form: {
    settings: {
      'Css Class': 'cssClass',
      'Css Class Options': 'cssClassOptions',
      'Is Ajax': 'isAjax',
      'Is Robot Detection Enabled': 'isRobotDetectionEnabled',
      'Is Template': 'isTemplate',
      Scripts: 'scripts',
      Styles: 'styles',
    },
  },
};
